import { styled } from '@mui/material'
import { memo } from 'react'
import { Link } from 'react-router-dom'
import { useCurrentThemeType } from 'store/settings/hooks'
import { MuiThemeType } from 'styles'
import { OnlyDesktop, OnlyMobile } from '../../../styles/Media'
import { ReactComponent as SvgLittleLogo } from './little-logo.svg'
import { ReactComponent as SvgLogo } from './logo.svg'
import { COMMUNITY_LINKS } from '../../../constants/community'

const LogoWrap = styled(Link)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.color.text100};
`

export const Logo = memo(() => {
  const theme = useCurrentThemeType()
  const fillColor = theme === MuiThemeType.dark ? 'white' : 'black'

  return (
    <LogoWrap to={COMMUNITY_LINKS.HOMEPAGE} target="_blank">
      <OnlyDesktop>
        <SvgLogo fill={fillColor} />
      </OnlyDesktop>
      <OnlyMobile>
        <SvgLittleLogo fill={fillColor} />
      </OnlyMobile>
    </LogoWrap>
  )
})
